import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';

interface SectionHeaderProps {
  badge?: string;
  badgeVariant?: 'teal' | 'orange' | 'dark';
  title: ReactNode;
  description?: string;
  centered?: boolean;
  dark?: boolean;
  className?: string;
}

export function SectionHeader({
  badge,
  badgeVariant = 'teal',
  title,
  description,
  centered = true,
  dark = false,
  className,
}: SectionHeaderProps) {
  return (
    <div
      className={cn(
        'max-w-2xl mb-10',
        centered && 'mx-auto text-center',
        className
      )}
    >
      <h2
        className={cn(
          'text-2xl sm:text-3xl font-bold mb-2',
          dark ? 'text-white' : 'text-slate-900'
        )}
      >
        {title}
      </h2>
      {description && (
        <p className={cn('text-sm', dark ? 'text-teal-100' : 'text-slate-600')}>
          {description}
        </p>
      )}
    </div>
  );
}
